module.exports = __webpack_public_path__ + "static/img/banniere2.2c827e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banniere2.jpg
// module id = NM6+
// module chunks = 1